// extracted by mini-css-extract-plugin
export default {"videotrackcontainer":"videochapters_videotrackcontainer__HLAIA","current":"videochapters_current__ijpU8"};